import { useIntl } from '@atlassian/jira-intl';
import type { Change } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/update-jira/types';
import type { Entity } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import messages from './messages';

type EntityCount = {
	[key in Entity]?: number;
} & {
	[key: string]: number;
};

export const useChangesInfo = () => {
	const { formatMessage } = useIntl();

	const convertArrayToString = (data: string[]) => {
		let resultString = '';

		if (data.length === 0) {
			resultString = '';
		} else if (data.length === 1) {
			resultString = data[0];
		} else if (data.length === 2) {
			resultString = formatMessage(messages.stringConnecter, {
				items: data[0],
				lastItem: data[1],
			});
		} else {
			const lastItem = data.pop();
			resultString = formatMessage(messages.stringConnecter, {
				items: data.join(', '),
				lastItem,
			});
		}
		return resultString;
	};

	const getCategoryCounts = (tableChanges: Change[]) => {
		// object to hold the count of each category changed
		const categoryCounts: EntityCount = {};
		tableChanges.forEach((item) => {
			if (item.category) {
				categoryCounts[item.category] = (categoryCounts[item.category] || 0) + 1;
			}
		});
		return categoryCounts;
	};

	const listChangeAuthors = (tableChanges: Change[], changesCount: number | undefined) => {
		if (tableChanges.length === changesCount) {
			return formatMessage(messages.allUsers);
		}
		const changeAuthorsSet = new Set<string>();
		tableChanges.forEach((item) => {
			if (item?.lastModified?.title) {
				changeAuthorsSet.add(item.lastModified.title);
			}
		});

		return convertArrayToString(Array.from(changeAuthorsSet));
	};

	const countCategories = (tableChanges: Change[]) => {
		const categoriesObj = getCategoryCounts(tableChanges);
		const categoryCounts: string[] = [];

		for (const [key] of Object.entries(categoriesObj)) {
			const formattedKey = key.toLowerCase().replace(/_/g, ' ');

			categoryCounts.push(
				formatMessage(messages.changedCategoryCount, {
					categoryCount: categoriesObj[key],
					changeCategory: formattedKey,
				}),
			);
		}

		return convertArrayToString(categoryCounts);
	};

	return { listChangeAuthors, countCategories };
};
